import { render, staticRenderFns } from "./AreaAnswer.vue?vue&type=template&id=1f5517fe&scoped=true"
import script from "./AreaAnswer.vue?vue&type=script&lang=js"
export * from "./AreaAnswer.vue?vue&type=script&lang=js"
import style0 from "./AreaAnswer.vue?vue&type=style&index=0&id=1f5517fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5517fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5517fe')) {
      api.createRecord('1f5517fe', component.options)
    } else {
      api.reload('1f5517fe', component.options)
    }
    module.hot.accept("./AreaAnswer.vue?vue&type=template&id=1f5517fe&scoped=true", function () {
      api.rerender('1f5517fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/seven/components/AreaAnswer.vue"
export default component.exports